import {
	getReport,apiHttp
} from "../../js/axios";
import el from "element-ui/src/locale/lang/el";
import axios from 'axios' //这里引入axios  mian无需再引
import Vue from "vue"; //引入Vue
Vue.prototype.$ajax = axios; //修改ajax原型指向为 axios
import Qs from 'qs';

import * as XLSX  from 'xlsx'


export default {
	name: 'goodslist',
	data() {
		return {
			searchTag: '', //查询id或手机号
			mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) -
				60,
			user: [], // 客户信息

			submiting: false, //正在请求

			pager: {
				count: 0,
				page: 1, // 默认第一页
				pagecount: 0,
				pagesize: 12 //默认一页12条数据
			},

			nowMobile: '', // 存储当前已查询企业用户id或手机号

			iframeUrl: '', // 下载报告路径

			companyList: [],
			enpId: '',
			dateValue: '',
			downFile: false,
			value: '0',
			alertShow: false,
			tipStatus: '',
			tipText: '',
			adminId: '',
			dateValue: '',
			http: apiHttp() + '/v1/back/export/',
			datePickValue:null,
			userInfo:{}
		}
	},

	mounted() {
		this.getList()
		const userInfo = JSON.parse(localStorage.getItem("userInfo") )
		this.userInfo = userInfo
	},

	watch: {
		
	},

	methods: {
		sortByCreatedTime({
			order,
			prop
		}) {
			if (order === null) {
				this.getList()
			} else if (prop == 'created_at') {
				this.getList({
					order_created: order == 'ascending' ? "ASC" : "DESC"
				})
			} else if (prop == 'updated_at') {
				this.getList({
					order_updated: order == 'ascending' ? "ASC" : "DESC"
				})
			}
		},
		resetPage() {
			this.pager = {
				count: 0,
				page: 1, // 默认第一页
				pagecount: 0,
				pagesize: 12 //默认一页12条数据
			}
		},
		accountInput(val) {
			let codeReg = new RegExp("[A-Za-z0-9]+");
			let len = val.length;
			let str = '';
			for (let i = 0; i < len; i++) {
				if (codeReg.test(val[i])) {
					str += val[i]
				}
			}
			this.nowMobile = str
			this.pager.page = 1
			this.getList();
		},
		handleEnp(id) {
			this.enpId = id
			this.nowMobile = ''
			this.dateValue = ''
			this.getList()
		},
		handleSelectionChange(val) {},
		downExcel() {
			if (this.dateValue == '' || this.dateValue[0] / 1000 == this.dateValue[1] / 1000 || this.value == '') {
				this.alertShow = true;
				this.tipStatus = "下载失败";
				this.tipText = "请选择合适的起止日期及信息";
			} else {
				this.$refs.down.click();

			}
		},
		confirmDialog() {
			this.alertShow = false;
		},
		closeDialog() {
			this.alertShow = false;
			//把绑定的弹窗数组 设为false即可关闭弹窗
		},
		phoneMustNumber(value) {
			this.nowMobile = value.replace(/[^0-9a-zA-Z]/g, '');
		},
		searchDateChange(val) {
			this.pager.page = 1
			this.getList();
		},
		query() {
			if (this.nowMobile) {
				
			}
			this.pager.page = 1
			this.getList();
		},
		handleReset() {
			this.nowMobile = '';
			this.pager.page = 1;
			this.dateValue = null
			this.getList();
		},
		handleUpdate(id, goods_id, type, row) {
			sessionStorage.setItem('report_id', id)
			sessionStorage.setItem("clickMenu", 6)
			this.$emit('updateMenuNum', 6)
			this.$router.push('/menu/question');
		},

		pageChange(page) {
			this.pager.page = page;
			this.getList();
		},

		getList(d = {}) {
			let data = {
				mobile: this.nowMobile,
				page: this.pager.page,
				created:this.dateValue || [],
				pagesize: this.pager.pagesize,
				...d
			}
			getReport(data).then(res => {
				if (res.code == 200) {
					let listData = JSON.parse(window.atob(res.data))
					if (listData.data.length == 0) {
						this.user = [];
						this.pager = {
							count: 0,
							page: 1, // 默认第一页
							pagecount: 0,
							pagesize: 12 //默认一页12条数据
						}
					} else {
						this.user = listData.data;
						//分页
						var pager = listData.pager;
						for (var key in pager) {
							pager[key] = parseInt(pager[key]);
						}
						this.pager = pager;
					}
				} else {
					this.resetPage()
					this.alertShow = true;
					this.tipStatus = "查詢失敗";
					this.tipText = res.msg;
				}
			});
		},
		hanleLoadAll() {
			// this.enpId = 0,
			this.nowMobile = '';
			this.dateValue = '';
			// this.getList();
		},
		// 时间戳转换日期
		timestampFormat(timestamp) {
			let dt = new Date(timestamp * 1000),
				y = dt.getFullYear(),
				m = dt.getMonth() + 1 >= 10 ? dt.getMonth() + 1 : ('0' + (dt.getMonth() + 1)),
				d = dt.getDate() >= 10 ? dt.getDate() : ('0' + dt.getDate());

			return y + '/' + m + '/' + d;
		},

		lookReport(id, pk, type) {
			if (pk && pk == 6) { // 母婴
				window.open('/report/mirrorReport.html?id=' + id);
			} else if (pk && pk == 7) { //AI健康
				window.open('/report/creamReport.html?id=' + id);
			} else if (pk && pk == 8) { //AI健康
				window.open('/report/lookReport.html?id=' + id);
			} else if (type && type == 'M22') {
				window.open('/report/m22Report.html?id=' + id);
			}
			// else{
			//      		let openUrl = this.$router.resolve({
			//      			path: "/reportPrint/lookReport",
			//      			query: {
			//      				id: id
			//      			}
			//      		});

			//      		window.open(openUrl.href);
			//      	}

		},
		// 下载报告
		download(id, pk, type) {
			if (pk && pk == 7) { //AI健康
				window.open('/report/creamDown.html?id=' + id);
			} else if (pk && pk == 8) { //AI健康
				window.open('/report/download.html?id=' + id);
			} else if (pk && pk == 6) { //AI健康
				window.open('/report/mirrorDown.html?id=' + id);
			} else if (type && type == 'M22') {
				window.open('/report/m22Download.html?id=' + id);
			}
		},
		//打印报告
		print(id, pk) {
			var iframeDoc = document.getElementById('iframe'),
				url = '';
			if (pk && pk == 3) { // 母婴
				url = "/muying/report/download.html?type=print&id=" + id;
			} else {
				url = this.$router.resolve({
					path: "/reportPrint/printTemplate",
					query: {
						id: id,
						type: 'print'
					}
				}).href;
			}

			if (this.iframeUrl == url && iframeDoc.contentWindow.getData) {
				iframeDoc.contentWindow.getData();
			} else {
				this.iframeUrl = url;
			}

		},
		handleExport(type){
			
			
			
			if(this.dateValue){
				const data = {
					created:this.dateValue,
					act:"export",
				}
				
				getReport(data).then(res => {
					if (res.code == 200) {
						let listData = JSON.parse(window.atob(res.data))
						if(Array.isArray(listData) && listData.length){
							const headers = {
								id:'编号',
								name:"姓名",
								yy_user_id:"订单号",
								created_at:"创建日期",
								updated_at:"更新时间"
							}
							const list = listData.map(d => {
								const order = {}
								Object.entries(headers).forEach(h => {
									order[h[1]] = d[h[0]]
								})
								return order
							})
							const date = new Date()
							
							this.exportToExcel(list,'香港体检报告记录'+this.getTarMonth()+' '+date.getHours()+date.getMinutes())
						}else{
							this.alertShow = true;
							this.tipStatus = "暂无数据";
						}
						
					} else{
						
					}
				})
			}else{
				this.alertShow = true;
				this.tipStatus = "请选择起始日期";
			}
		},
		datePickerDisableedDate(date,datePickValue){
			if(Array.isArray(datePickValue) && datePickValue.length){
				const startDate = new Date(this.getTarMonth(-2,datePickValue[0]))
				const endDate = new Date(this.getTarMonth(2,datePickValue[0]))
				return (date.getTime() < startDate.getTime() || date.getTime() >= endDate.getTime())
			}else{
				return false
			}
			
		},
		
		getTarMonth(num=0,time = new Date()){
			const today = time
			let year = today.getFullYear()
			let month = today.getMonth() + 1 + num
			const multiple = Math.floor(month/12)
			
			year = Math.floor(year + multiple)
			if(month > 0){
				month = month % 12
			}else if(month == 0){
				year -- 
				month = 12
			}else{
				month = 12 - (Math.abs(month) % 12)
			}
			const tMonth = month < 10 ? `0${month}` : month
			let d = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate()
			return `${year}-${tMonth}-${d}`
		},
		dateValueChange(val){
			this.datePickValue = []
		},
		onDatePick({minDate,maxDate}){
			this.datePickValue = [minDate,maxDate]
		},
		restDateValue(){
			this.datePickValue = []
		},
		exportToExcel(data,fileName){
			const worksheet = XLSX.utils.json_to_sheet(data)
			const workbook = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(workbook,worksheet,'列表1')
			const excelBuffer = XLSX.write(workbook,{bookType:'xlsx',type:'array'})
			const excelData = new Blob([excelBuffer],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml'})
			let fileData = URL.createObjectURL(excelData)
			
			const link = document.createElement('a')
			link.href = fileData
			link.download = fileName + '.xlsx'
			link.click()
		}
	}
}